import { render } from "./EmailConfirmationResend.vue?vue&type=template&id=05a01fe7&scoped=true"
import script from "./EmailConfirmationResend.vue?vue&type=script&lang=js"
export * from "./EmailConfirmationResend.vue?vue&type=script&lang=js"

import "./EmailConfirmationResend.vue?vue&type=style&index=0&id=05a01fe7&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05a01fe7"]])

export default __exports__